import { gql } from '@apollo/client';

export type {
  GetReports as IGetReports,
  GetReportsVariables as IGetReportsVariables,
  GetReports_reports as IReportData,
} from './__generated__/GetReports';

export const GET_REPORTS = gql`
  query GetReports(
    $marketNames: [String!]!
    $startDate: String
    $endDate: String
    $reportId: String
  ) {
    reports(
      marketNames: $marketNames
      startDate: $startDate
      endDate: $endDate
      reportId: $reportId
    ) {
      reportId
      url
    }
  }
`;
